var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelivered(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5942 3H6.4058C4.5257 3.00198 3.00198 4.5257 3 6.4058V22.05C3.00198 23.9301 4.5257 25.4536 6.4058 25.4558H14.0391L17.1296 30.571C17.1316 30.5742 17.1338 30.5776 17.1358 30.581C17.302 30.8417 17.5896 30.9996 17.8987 30.9996C18.208 30.9996 18.4956 30.8417 18.6618 30.581L18.668 30.571L21.7585 25.4558H29.5942C31.4743 25.4536 32.998 23.9301 33 22.05V6.4058C32.998 4.5257 31.4743 3.00198 29.5942 3ZM31.9855 22.05C31.9841 23.37 30.9141 24.4397 29.5942 24.4413H21.4723C21.2948 24.4413 21.1301 24.5342 21.0384 24.6862L17.8989 29.8818L14.7592 24.6862C14.6675 24.5342 14.5028 24.4413 14.3253 24.4413H6.4058C5.08588 24.4397 4.01591 23.37 4.01449 22.05V6.4058C4.01591 5.0856 5.0856 4.01591 6.4058 4.01449H29.5942C30.9144 4.01591 31.9841 5.0856 31.9855 6.4058V22.05Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0842 10.7123L16.507 16.9943L12.9237 13.4107C12.7256 13.2126 12.4046 13.2126 12.2065 13.4107C12.0083 13.6089 12.0083 13.9302 12.2065 14.1283L16.1405 18.0623C16.3355 18.2573 16.6502 18.2607 16.8495 18.0705L23.7851 11.446C23.9875 11.2524 23.9948 10.9314 23.8015 10.7287C23.6079 10.5261 23.2869 10.5187 23.0842 10.7123Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivered);
export default __webpack_public_path__ + "static/media/delivered.57ad69f356f3494a50fdc7c06690a440.svg";
export { ForwardRef as ReactComponent };